<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickable" @click="msgAlerta=null">{{ msgAlerta }}</div>


    <div v-show="!modoEdicao && !modoAbertura && !modoView">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <div class="field-label field-label--destaque">{{ modeloSelecionado?.nmprocesso }}</div>
                </div>
            </div>
            
            <div class="row row-space">
                <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>

                <div class="form-item">
                    <div v-if="globalStore.idestabelecimento">
                        <label class="label-caption">Estabelecimento</label>
                        <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
                    </div>
                    <div v-else>
                        <EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" />
                    </div>
                </div>

                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--add" @click="showModalEstabelecimento = true" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>

        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th>Data</th>
                    <th>Hora</th>
                    <th>Protocolo</th>
                    <th>S.I.M.</th>
                    <th>Estabelecimento</th>
                    <th>Nro SIM</th>
                    <th>Situação</th>
                    <th>Etapa Atual</th>
                </tr></thead>

                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.idregistro" @click="visualizarProcesso(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtprocesso) }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatTimeFromJson(obj.hrprocesso) }}</td>
                        <td class="col-width-char20">{{ obj.protocolo }}</td>
                        <td class="col-width-char30">{{ obj.nmsim }}</td>
                        <td>{{ obj.nmestabelecimento }}</td>
                        <td class="col-width-char10 center">{{ obj.nrosim }}</td>
                        <td class="col-width-char20">{{ obj.nmstatus }}</td>
                        <td class="col-width-char40">{{ obj.nmetapa }}</td>
                    </tr>
                </tbody>
            </table>



            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
    </div>


    <div v-if="modoAbertura">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Processo</label>
                    <div class="field-label field-label--destaque">{{ modeloSelecionado?.nmprocesso }}</div>
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item-char40">
                    <label class="label-caption">S.I.M.</label>
                    <div class="field-label field-label--destaque">{{ estabelecimentoDocSelecionado?.nmsim }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label field-label--destaque">{{ estabelecimentoDocSelecionado?.nmestabelecimento }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Atividade</label>
                    <div class="field-label field-label--destaque">{{ estabelecimentoDocSelecionado?.nmatividade }}</div>
                </div>
            </div>
        </div>


        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Etapa Inicial:</label>
                    <div class="field-label">{{ etapaInicial?.nmetapa }}</div>
                </div>
            </div>

            
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Instruções:</label>
                    <textarea :value="etapaInicial?.descricao || ''" rows="5" maxlength="3000" readonly></textarea>
                </div>
            </div>
        </div>


        <div class="row-end">
            <button class="btn-confirm" @click="gerarProcesso">Iniciar Novo Processo</button>
            <button class="btn-small" @click="modoAbertura=false">Retornar</button>
        </div>
    </div>


    <EstabelecimentoPesquisaModal
        :showModal="showModalEstabelecimento"
        @close="showModalEstabelecimento = false"
        @objSelecionado="setEstabelecimentoProc"
    />


    <div v-if="modoEdicao">
        <ProcEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="lerDados" />
    </div>


    <div v-if="modoView">
        <ProcViewPage :idProcesso="idView" @close="modoView = false" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import EstabelecimentoPesquisaModal from '@/components/modals/EstabelecimentoPesquisaModal.vue';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import ProcEditPage from '../formularios/ProcEditPage.vue';
import ProcViewPage from '../outros/ProcViewPage.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';

const props = defineProps({idProcesso: Number});

const estabelecimentoSelecionado = ref(null);
const estabelecimentoDocSelecionado = ref(null);
const modeloSelecionado = ref(null);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const emit = defineEmits(['close']);
const idEdicao = ref(null);
const idView = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoAbertura = ref(false);
const modoEdicao = ref(false);
const modoView = ref(false);
const msgAlerta = ref(null);
const showModalEstabelecimento = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const etapaInicial = ref(null);

const closeForm = () => {emit('close');}


async function gerarProcesso(){
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        const payload = {
            nmrequisicao: "processoGerar",
            idep: globalStore.idep,
            idsim: estabelecimentoDocSelecionado.value.idsim,
            idestabelecimento: estabelecimentoDocSelecionado.value.id,
            idreferencia: modeloSelecionado.value.id,
            idlogin: globalStore.idlogin,
        };

        const resp = await Api.genericPost('/rotinas/executar', payload);
        if (resp.bolok === 1){
            // CHAMAR ABERTURA DE EDIÇÃO
            console.log(resp);
            lerDados();
            modoAbertura.value=false;
        } else {
            msgAlerta.value=`ATENÇÃO: ${resp.erro}`;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function lerDados() {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const payload = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: 0,// ((globalStore.ckperfilestabelecimento) || (globalStore.ckperfilrt)) ? globalStore.idestabelecimento : estabelecimentoSelecionado.value,
            idreferencia: modeloSelecionado.value.id,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate};
        const req = await Api.genericPost('/dados/proc/processo', payload);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function lerModelos() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/proc/modelo', {
            id: props.idProcesso,
            idep: globalStore.idep,
            ativo: "S"
        });
        modeloSelecionado.value = req[0];
        lerDados();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function setEstabelecimentoProc(obj) {
    estabelecimentoDocSelecionado.value = obj;
    modoAbertura.value = true;
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/proc/modelo/etapa', {
            idreferencia: modeloSelecionado.value.id
        });
        etapaInicial.value = req[0] || null;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


function visualizarProcesso(obj) {
    idView.value = obj.id;
    modoView.value = true;
}


onMounted(lerModelos)
</script>